export const AUTH_TOKEN = 'auth:token';
export const ID_PARTNER = 'id:partner';
export const DATE_FORMAT = 'DD.MM.YYYY';
